import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { apiRequest } from '../../api';
import CustomDropdown from '../../components/CustomDropdown';
import './Login.css';

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    spaceId: ''
  });
  const [spaces, setSpaces] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadSpaces = async () => {
      try {
        const response = await apiRequest('/spaces');
        if (response?.spaces) {
          setSpaces(response.spaces);
          if (!formData.spaceId && response.spaces.length > 0) {
            setFormData(prev => ({ ...prev, spaceId: String(response.spaces[0].id) }));
          }
        }
      } catch (err) {
        setSpaces([]);
      }
    };
    loadSpaces();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(formData.username, formData.password, formData.spaceId);
    
    if (result.success) {
      navigate('/shifts');
    } else {
      setError(result.message);
    }
    
    setLoading(false);
  };

  // Заполнить тестовыми данными (если нужно)
  const fillTestData = (userType) => {
    const TEST_USERS = {
      admin: {
        username: 'admin',
        password: 'admin123'
      },
      manager: {
        username: 'manager',
        password: 'manager123'
      },
      employee: {
        username: 'employee',
        password: 'employee123'
      }
    };
    
    setFormData({
      username: TEST_USERS[userType].username,
      password: TEST_USERS[userType].password,
      spaceId: formData.spaceId
    });
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Вход в ShiftMaster</h1>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Имя пользователя:</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              autoComplete="username"
              onChange={handleChange}
              placeholder="Введите имя пользователя"
              required
            />
          </div>
          
          <div className="form-group">
            <label>Пароль:</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              autoComplete="current-password"
              onChange={handleChange}
              placeholder="Введите пароль"
              required
            />
          </div>

          <div className="form-group">
            <label>Пространство:</label>
            <CustomDropdown
              options={spaces.map(space => ({
                value: String(space.id),
                label: space.name
              }))}
              value={formData.spaceId}
              onChange={(value) => setFormData(prev => ({ ...prev, spaceId: value }))}
              placeholder={spaces.length === 0 ? 'Загрузка...' : 'Выберите пространство'}
            />
          </div>
          
          <button 
            type="submit" 
            className="add-button"
            disabled={loading}
          >
            {loading ? 'Вход...' : 'Войти'}
          </button>
        </form>

       
      </div>
    </div>
  );
};

export default Login;
